import React from 'react';
import { RoundResult } from '@shared/types';

interface RoundResultModalProps {
  result: RoundResult;
  roundNumber: number;
  onDismiss: () => void;
}

export const RoundResultModal: React.FC<RoundResultModalProps> = ({
  result,
  roundNumber,
  onDismiss,
}) => {
  const winner = result.scores.find(s => s.isWinner);

  return (
    <div className="result-overlay" onClick={onDismiss}>
      <div className="result-card" onClick={e => e.stopPropagation()}>
        <div className="result-title">⭐ EL {roundNumber} BİTTİ</div>

        {winner && (
          <div style={{
            textAlign: 'center',
            marginBottom: 16,
            fontSize: 14,
            color: 'var(--color-success)',
          }}>
            🏆 {winner.nickname} kazandı!
          </div>
        )}

        <table className="score-table">
          <thead>
            <tr>
              <th>Oyuncu</th>
              <th>Bu El</th>
              <th>Toplam</th>
            </tr>
          </thead>
          <tbody>
            {result.scores.map(score => (
              <tr key={score.playerId} className={score.isWinner ? 'winner' : ''}>
                <td>
                  {score.isWinner && '🏆 '}
                  {score.nickname}
                </td>
                <td className={score.roundScore >= 0 ? 'score-positive' : 'score-negative'}>
                  {score.roundScore >= 0 ? '+' : ''}{score.roundScore}
                </td>
                <td>{score.totalScore}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', marginBottom: 16 }}>
          Yeni el 5 saniye içinde başlıyor...
        </div>

        <button className="btn btn-green btn-lg" style={{ width: '100%' }} onClick={onDismiss}>
          DEVAM
        </button>
      </div>
    </div>
  );
};

export default RoundResultModal;
